<template>
   <p v-if="metadataStore.conferenceDate">{{  metadataStore.conferenceDate }}, 9:00-18:00</p>
</template>

<script setup>
  import { useMetadataStore } from "../stores/metadata";
  const metadataStore = useMetadataStore();
</script>
